//! Получение контейнеров организации
import axios from './configAxios';

export const getContainersOrgApi = async (terminal_id, org_id, page) => {
	return axios.get(`/?&terminal_id=${terminal_id}&client_id=${org_id}&gate_out_available=true`);
};
